import React, { useState } from "react";

export default function PdfConfigScreen() {
  const [mode, setMode] = useState("");
  const [referencePdfUrl, setReferencePdfUrl] = useState(null);
  const [referencePdf, setReferencePdf] = useState(null);
  const [inputPdf, setInputPdf] = useState(null);
  
  const [fieldsRows, setFieldsRows] = useState([
    { f1: "", t1: "", ref1: "", f2: "", t2: "", ref2: "" },
  ]);

  const [tableRows, setTableRows] = useState([{ name: "", type: "" }]);

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  /* ---------- Fields handlers ---------- */
  const addFieldRow = () => {
    setFieldsRows([...fieldsRows, { f1: "", t1: "", ref1: "", f2: "", t2: "", ref2: "" }]);
  };

  const deleteFieldRow = (index) => {
    if (fieldsRows.length === 1) {
      alert("Can't delete, It's last row");
      return;
    }
    setFieldsRows(fieldsRows.filter((_, i) => i !== index));
  };

  /* ---------- Table handlers ---------- */
  const addTableRow = () => {
    setTableRows([...tableRows, { name: "", type: "" }]);
  };

  const deleteTableRow = (index) => {
    if (tableRows.length === 1) {
      alert("Can't delete, It's last row");
      return;
    }
    setTableRows(tableRows.filter((_, i) => i !== index));
  };
  const handleSubmit = async () => {
    if (!mode || !referencePdf) {
      alert("Mode & Reference PDF required");
      return;
    }

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const formData = new FormData();
      formData.append("mode", mode);
      formData.append("reference_pdf", referencePdf);

      if (inputPdf) {
        formData.append("input_pdf", inputPdf);
      }

      // ?? FIELDS MODE
      if (mode === "fields") {
        // Collect all fields from all rows
        const fields = [];
        fieldsRows.forEach((row) => {
          // Field 1
          if (row.f1 && row.t1 && row.ref1) {
            fields.push({
              header: row.f1,
              value_type: row.t1,
              reference_value: row.ref1,
            });
          }
          // Field 2
          if (row.f2 && row.t2 && row.ref2) {
            fields.push({
              header: row.f2,
              value_type: row.t2,
              reference_value: row.ref2,
            });
          }
        });

        if (fields.length === 0) {
          alert("Please fill at least one field with name, type, and reference value");
          setLoading(false);
          return;
        }

        formData.append("fields", JSON.stringify(fields));
      }

      // ?? TABLE MODE
      if (mode === "table") {
        const headers = tableRows.map((r) => r.name).filter((h) => h.trim());
        if (headers.length === 0) {
          alert("Please add at least one column name");
          setLoading(false);
          return;
        }
        formData.append("headers", JSON.stringify(headers));
      }

      const res = await fetch("http://localhost:8000/process-pdf/", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      
      if (!res.ok || !data.success) {
        setError(data.error || data.reason || "Processing failed");
      } else {
        setResult(data);
      }
    } catch (err) {
      setError(err.message || "Network error occurred");
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="full-panel">
      <h3>PDF Screen</h3>

      <div className="split-container">
        {/* ================= LEFT PANEL ================= */}
        <div className="left-panel">
          {/* ?? Reference PDF */}
          <h4>Upload PDFs</h4>

          <div className="pdf-upload-row">
            {/* Reference PDF */}
            <div className="pdf-upload-item">
              <label>
                <b>Reference PDF</b>
              </label>
              <input
                type="file"
                accept="application/pdf"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    setReferencePdf(file);
                    const url = URL.createObjectURL(file);
                    setReferencePdfUrl(url);
                  }
                }}
              />
            </div>

            {/* Test PDF */}
            <div className="pdf-upload-item">
              <label>
                <b>Test PDF</b>
              </label>
              <input
                type="file"
                accept="application/pdf"
                onChange={(e) => setInputPdf(e.target.files[0])}
              />
            </div>
          </div>

          {referencePdf && (
            <div style={{ marginTop: "15px" }}>
              <h4>Reference PDF Preview</h4>

              <iframe
                src={`${referencePdfUrl}`}
                title="Reference PDF"
                width="100%"
                height="600px"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              />
            </div>
          )}
        </div>

        {/* ================= RIGHT PANEL ================= */}
        <div className="right-panel">
          {/* ?? TAB PANEL */}

          {/* ================= TAB CONTENT ================= */}
          <>
            {/* -------- Mode Dropdown -------- */}
            <select value={mode} onChange={(e) => setMode(e.target.value)}>
              <option value="">Select</option>
              <option value="fields">Fields</option>
              <option value="table">Table</option>
            </select>

            <br />
            <br />

            {/* ================= Fields Mode ================= */}
            {mode === "fields" && (
              <div>
                <h4>Fields</h4>

                <div className="header-row">
                  <span>Field Name</span>
                  <span>Type</span>
                  <span>Ref Value</span>
                  <span>Field Name</span>
                  <span>Type</span>
                  <span>Ref Value</span>
                  <span>Action</span>
                </div>

                {fieldsRows.map((row, index) => (
                  <div key={index} className="field-row">
                    <input
                      placeholder="Field 1"
                      value={row.f1}
                      onChange={(e) => {
                        const updated = [...fieldsRows];
                        updated[index].f1 = e.target.value;
                        setFieldsRows(updated);
                      }}
                    />

                    <select
                      value={row.t1}
                      onChange={(e) => {
                        const updated = [...fieldsRows];
                        updated[index].t1 = e.target.value;
                        setFieldsRows(updated);
                      }}
                    >
                      <option value="">Type</option>
                      <option value="text">Text</option>
                      <option value="int">Int</option>
                      <option value="decimal">Decimal</option>
                      <option value="date">Date</option>
                      <option value="id">ID</option>
                    </select>

                    <input
                      placeholder="Ref Value"
                      value={row.ref1}
                      onChange={(e) => {
                        const updated = [...fieldsRows];
                        updated[index].ref1 = e.target.value;
                        setFieldsRows(updated);
                      }}
                    />

                    <input
                      placeholder="Field 2"
                      value={row.f2}
                      onChange={(e) => {
                        const updated = [...fieldsRows];
                        updated[index].f2 = e.target.value;
                        setFieldsRows(updated);
                      }}
                    />

                    <select
                      value={row.t2}
                      onChange={(e) => {
                        const updated = [...fieldsRows];
                        updated[index].t2 = e.target.value;
                        setFieldsRows(updated);
                      }}
                    >
                      <option value="">Type</option>
                      <option value="text">Text</option>
                      <option value="int">Int</option>
                      <option value="decimal">Decimal</option>
                      <option value="date">Date</option>
                      <option value="id">ID</option>
                    </select>

                    <input
                      placeholder="Ref Value"
                      value={row.ref2}
                      onChange={(e) => {
                        const updated = [...fieldsRows];
                        updated[index].ref2 = e.target.value;
                        setFieldsRows(updated);
                      }}
                    />

                    <button
                      className="icon-btn delete"
                      onClick={() => deleteFieldRow(index)}
                    >
                      ??
                    </button>
                  </div>
                ))}

                <button className="icon-btn add" onClick={addFieldRow}>
                  ?
                </button>
              </div>
            )}

            {/* ================= Table Mode ================= */}
            {mode === "table" && (
              <div>
                <h4>Table</h4>

                <div className="header-row table">
                  <span>Column Name</span>
                  <span>Type</span>
                  <span>Action</span>
                </div>

                {tableRows.map((row, index) => (
                  <div key={index} className="table-row">
                    <input
                      placeholder="Column Name"
                      value={row.name}
                      onChange={(e) => {
                        const updated = [...tableRows];
                        updated[index].name = e.target.value;
                        setTableRows(updated);
                      }}
                    />

                    <select
                      value={row.type}
                      onChange={(e) => {
                        const updated = [...tableRows];
                        updated[index].type = e.target.value;
                        setTableRows(updated);
                      }}
                    >
                      <option value="">Type</option>
                      <option value="text">Text</option>
                      <option value="int">Int</option>
                      <option value="decimal">Decimal</option>
                      <option value="date">Date</option>
                    </select>

                    <button
                      className="icon-btn delete"
                      onClick={() => deleteTableRow(index)}
                    >
                      ??
                    </button>
                  </div>
                ))}

                <button className="icon-btn add" onClick={addTableRow}>
                  ?
                </button>
              </div>
            )}
            <button
              onClick={handleSubmit}
              disabled={loading}
              style={{ 
                marginTop: "20px", 
                padding: "8px 16px",
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.6 : 1
              }}
            >
              {loading ? "Processing..." : "Process PDF"}
            </button>

            {/* Results Display */}
            {error && (
              <div style={{ 
                marginTop: "20px", 
                padding: "10px", 
                backgroundColor: "#fee", 
                border: "1px solid #fcc",
                borderRadius: "4px",
                color: "#c00"
              }}>
                <strong>Error:</strong> {error}
              </div>
            )}

            {result && (
              <div style={{ 
                marginTop: "20px", 
                padding: "15px", 
                backgroundColor: "#f0f0f0", 
                border: "1px solid #ccc",
                borderRadius: "4px"
              }}>
                <h4>Results:</h4>
                
                {mode === "fields" && result.fields && (
                  <div>
                    <p><strong>Total Fields:</strong> {result.total_fields}</p>
                    <p><strong>Successful:</strong> {result.successful_extractions}</p>
                    <div style={{ marginTop: "10px" }}>
                      {result.fields.map((field, idx) => (
                        <div key={idx} style={{ 
                          marginBottom: "10px", 
                          padding: "10px", 
                          backgroundColor: field.success ? "#dfd" : "#fdd",
                          border: "1px solid #ccc",
                          borderRadius: "4px"
                        }}>
                          <strong>{field.header}</strong> ({field.value_type})
                          {field.success ? (
                            <div style={{ marginTop: "5px" }}>
                              <strong>Extracted:</strong> {field.fetched_from_test || field.value}
                              {field.confidence && <span> (Confidence: {field.confidence})</span>}
                            </div>
                          ) : (
                            <div style={{ marginTop: "5px", color: "#c00" }}>
                              <strong>Failed:</strong> {field.reason || field.error || "Unknown error"}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {mode === "table" && result.rows && (
                  <div>
                    <p><strong>Rows Extracted:</strong> {result.rows.length}</p>
                    {result.page_found && <p><strong>Page:</strong> {result.page_found + 1}</p>}
                    {result.rows.length > 0 && (
                      <div style={{ marginTop: "10px", maxHeight: "400px", overflow: "auto" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                          <thead>
                            <tr style={{ backgroundColor: "#ddd" }}>
                              {Object.keys(result.rows[0]).map((key) => (
                                <th key={key} style={{ padding: "5px", border: "1px solid #999", textAlign: "left" }}>
                                  {key}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {result.rows.map((row, idx) => (
                              <tr key={idx}>
                                {Object.values(row).map((val, colIdx) => (
                                  <td key={colIdx} style={{ padding: "5px", border: "1px solid #ccc" }}>
                                    {val || ""}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </>
        </div>
      </div>
    </div>
  );
}
